import React, { useEffect, useState } from 'react'
import { pointCardMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import { ddayjs } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  pointInfo: IPointsInfoStyle;
}

const PointsCardLayout: React.FC<IProps> = props => {
  const history = useHistoryNew()
  const { pointInfo } = props
  const [pointActInfo, setPointActInfo] = useState<any>({})
  const [rotate, setRotate] = useState<number>(0)
  const [actStatus, setActStatus] = useState<number>(1) // 0未开始 1进行中 2已结束 3满点

  useEffect(() => {
    pointCardMobx.getPointCardDetail(pointInfo.activityId).then((res) => {
      if (res) {
        setPointActInfo(res)
        if (Date.now() > ddayjs(res.endTime).valueOf() || res.status === 'disable') {
          setActStatus(2)
        } else if (Date.now() < ddayjs(res.startTime).valueOf()) {
          setActStatus(0)
        } else if (res.points >= res.collectPointTarget) {
          setActStatus(3)
        } else {
          setActStatus(1)
        }
        if (pointInfo.content === 'square') {
          setRotate(Math.ceil((res.points > res.collectPointTarget ? res.collectPointTarget : res.points) * 360 / res.collectPointTarget))
        }
      }
    })
  }, [])

  return (
    <div data-cypid='mmgToPointCardDetail' className='points-card-layout' style={{ color: pointInfo.textColor }} onClick={() => history.push(`pointCard/detail/${pointInfo.activityId}`)}>
      {
        pointActInfo.activityId &&
          <>
            {
              pointInfo.content === 'titIcon' && pointInfo.titIconDes === 'compact' &&
                <div className='layout-compact-block'>
                  <div className='layout-title-icon' style={{ fontSize: `${pointInfo.fontSize}px` }}>{actStatus === 2 ? i18n.t('mkt.market.eventIsOver') : actStatus === 0 ? i18n.t('mkt.market.activityNotStart') : actStatus === 3 ? i18n.t('mkt.market.haveRewards') : pointActInfo.activityName}</div>
                  <div className='point-list'>
                    {[
                      ...Array(pointActInfo.collectPointTarget > 5 ? 4 : pointActInfo.collectPointTarget),
                    ].map((item: any, index: number) => {
                      let icon: string = ''
                      let dIcon: string = ''
                      if (pointInfo.iconInfo?.type === 'img') {
                        icon = pointInfo.iconInfo?.url
                        dIcon = pointInfo.iconInfo?.disUrl || ''
                      } else {
                        icon = pointInfo.iconInfo?.url
                        dIcon = pointInfo.iconInfo?.disUrl
                      }
                      return (
                        <div
                          className='point-item'
                          style={{
                            width: '18px',
                            height: '18px',
                            backgroundImage:
                              index < pointActInfo.points
                                ? `Url(${icon})`
                                : `Url(${dIcon})`,
                          }}
                          key={index}
                        >
                        </div>
                      )
                    })}
                    {
                      pointActInfo.collectPointTarget > 5 ? (
                        <div
                          className='point-item'
                        >
                          <i className='iconfont icon-ellipsis' style={{ color: pointInfo.textColor }}></i>
                        </div>
                      ) : null
                    }
                  </div>
                  <div className='layout-title-icon-num' style={{ fontSize: `${pointInfo.pointFontSize === 16 ? 14 : pointInfo.pointFontSize}px` }}><span style={{ fontSize: `${pointInfo.pointFontSize}px`, fontWeight: 600 }}>{pointActInfo.points > pointActInfo.collectPointTarget ? pointActInfo.collectPointTarget : pointActInfo.points}</span>/{pointActInfo.collectPointTarget}</div>
                </div>
            }
            {
              (pointInfo.content === 'titIcon' && pointInfo.titIconDes === 'loose' || pointInfo.content === 'progressBar') &&
                <div className='layout-loose-block'>
                  <div className='layout-loose-block-top'>
                    <div className='layout-title-icon' style={{ fontSize: `${pointInfo.fontSize}px` }}>{actStatus === 2 ? i18n.t('mkt.market.eventIsOver') : actStatus === 0 ? i18n.t('mkt.market.activityNotStart') : actStatus === 3 ? i18n.t('mkt.market.haveRewards') : pointActInfo.activityName}</div>
                    <div className='layout-title-icon-num' style={{ fontSize: `${pointInfo.pointFontSize === 16 ? 14 : pointInfo.pointFontSize}px` }}><span style={{ fontSize: `${pointInfo.pointFontSize}px`, fontWeight: 600 }}>{pointActInfo.points > pointActInfo.collectPointTarget ? pointActInfo.collectPointTarget : pointActInfo.points}</span>/{pointActInfo.collectPointTarget}</div>
                  </div>
                  {
                    pointInfo.content === 'progressBar' ? (
                      <div className='layout-bar' style={{ backgroundColor: pointInfo.barColor }}>
                        <div className='layout-bar-block' style={{ backgroundColor: pointInfo.blockColor, width: pointActInfo.points >= pointActInfo.collectPointTarget ? '100%' : `${pointActInfo.points / pointActInfo.collectPointTarget * 100}%` }}></div>
                      </div>
                    ) : (
                      <div className='point-list'>
                        {[
                          ...Array(pointActInfo.collectPointTarget > 10 ? 9 : pointActInfo.collectPointTarget),
                        ].map((item: any, index: number) => {
                          let icon: string = ''
                          let dIcon: string = ''
                          if (pointInfo.iconInfo?.type === 'img') {
                            icon = pointInfo.iconInfo?.url
                            dIcon = pointInfo.iconInfo?.disUrl || ''
                          } else {
                            icon = pointInfo.iconInfo?.url
                            dIcon = pointInfo.iconInfo?.disUrl
                          }
                          return (
                            <div
                              className='point-item point-item-loose'
                              style={{
                                backgroundImage:
                                  index < pointActInfo.points
                                    ? `Url(${icon})`
                                    : `Url(${dIcon})`,
                              }}
                              key={index}
                            >
                            </div>
                          )
                        })}
                        {
                          pointActInfo.collectPointTarget > 10 ? (
                            <div
                              className='point-item'
                            >
                              <i className='iconfont icon-ellipsis' style={{ color: pointInfo.textColor }}></i>
                            </div>
                          ) : null
                        }
                      </div>
                    )
                  }
                </div>
            }
            {
              pointInfo.content === 'square' &&
                <div className='layout-square-block'>
                  {
                    pointInfo.squareDes === 'top' && <div className='layout-square-block-text' style={{ fontSize: `${pointInfo.fontSize}px` }}>{actStatus === 2 ? i18n.t('mkt.market.eventIsOver') : actStatus === 0 ? i18n.t('mkt.market.activityNotStart') : actStatus === 3 ? i18n.t('mkt.market.haveRewards') : pointActInfo.activityName}</div>
                  }
                  <div className='layout-square-block-icon'>
                    <div className='layout-square-block-left'>
                      <div className='leftcircle' style={rotate > 180 ? { borderLeft: `3px solid ${pointInfo.textColor}`, borderTop: `3px solid ${pointInfo.textColor}`, transform: `rotate(${rotate - 45}deg)` } : {}}></div>
                    </div>
                    <div className='layout-square-block-right'>
                      <div className='rightcircle' style={pointActInfo.points > 0 ? { borderLeft: `3px solid ${pointInfo.textColor}`, borderTop: `3px solid ${pointInfo.textColor}`, transform: `rotate(${-45 + (rotate > 180 ? 180 : rotate)}deg)` } : {}}></div>
                    </div>
                    <div className='layout-square-block-icon-top' style={{ backgroundImage: `Url(${pointInfo.iconInfo?.url})` }}></div>
                    <div className='layout-square-block-icon-bottom' style={{ fontSize: `${pointInfo.pointFontSize === 16 ? 14 : pointInfo.pointFontSize}px` }}><span style={{ fontSize: `${pointInfo.pointFontSize}px`, fontWeight: 600 }}>{pointActInfo.points > pointActInfo.collectPointTarget ? pointActInfo.collectPointTarget : pointActInfo.points}</span>/{pointActInfo.collectPointTarget}</div>
                  </div>
                  {
                    pointInfo.squareDes === 'bottom' && <div className='layout-square-block-text' style={{ fontSize: `${pointInfo.fontSize}px` }}>{actStatus === 2 ? i18n.t('mkt.market.eventIsOver') : actStatus === 0 ? i18n.t('mkt.market.activityNotStart') : actStatus === 3 ? i18n.t('mkt.market.haveRewards') : pointActInfo.activityName}</div>
                  }
                </div>
            }
          </>
      }
    </div>
  )
}

export default PointsCardLayout
